import { gql } from '@apollo/client';
import { WarrantyIssueInfo } from '../fragments';

export default gql`
  query warrantyIssues {
    warrantyIssues {
      ...WarrantyIssueInfo
    }
  }
  ${WarrantyIssueInfo}
`;
